import { InventoryTypeKey, InventoryTypeId } from '~/constants/inventoryType';

type OwnProps = {
  jellyBeanMobileUrl?: string;
  vehicleInventoryType: InventoryTypeId | InventoryTypeKey;
  stockNumber: number;
};

const cvnaVexFastlyImageUrl = 'https://vexgateway.fastly.carvana.io';
const cvnaAppAssetsCdn = process.env.CVNA_APP_CDN_URL ?? '';

export default function getImageToUse({
  jellyBeanMobileUrl,
  stockNumber,
  vehicleInventoryType
}: OwnProps) {
  const hasJellyBeanUrl = Boolean(jellyBeanMobileUrl);
  const hasStockNumber = Boolean(stockNumber);
  const isWip =
    vehicleInventoryType === InventoryTypeId.WIP ||
    vehicleInventoryType === InventoryTypeKey.WIP;

  if (!hasStockNumber && !hasJellyBeanUrl) {
    return `${cvnaAppAssetsCdn}/search-assets/noevox.png`;
  }

  return isWip
    ? (jellyBeanMobileUrl as string)
    : `${cvnaVexFastlyImageUrl}/${stockNumber}/standardizedHero.jpg?width=256&crop=4:3`;
}
